import React, { useMemo, useState } from "react";
import { Search } from "lucide-react";

const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

export default function PendingRegistrationList({ submissions }) {
  const [query, setQuery] = useState("");

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return submissions;
    return submissions.filter(
      (s) =>
        s.company.toLowerCase().includes(q) ||
        s.contactName.toLowerCase().includes(q) ||
        s.email.toLowerCase().includes(q)
    );
  }, [submissions, query]);

  return (
    <div className="px-6 py-6 text-left">
      <h2 className="mb-6 text-xl font-semibold text-[#1D2739]">
        Pending Registration
      </h2>

      <div className="mb-6 flex items-center gap-2">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
          <input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search"
            className="w-[320px] rounded-lg bg-gray-100 py-2 pl-10 pr-3 text-sm outline-none focus:ring-2 focus:ring-blue-200"
          />
        </div>
        <button
          type="button"
          className="rounded-lg bg-blue-500 px-5 py-2 text-sm font-medium text-white hover:bg-blue-600"
        >
          Search
        </button>
      </div>

      {filtered.length === 0 ? (
        <p className="py-16 text-center text-sm text-gray-500">
          No pending registrations.
        </p>
      ) : (
        <div className="overflow-visible rounded-xl border border-gray-100">
          <table className="w-full text-left text-sm">
            <thead className="border-b border-gray-100 bg-white text-gray-500">
              <tr>
                <th className="px-4 py-3 font-medium">Company</th>
                <th className="px-4 py-3 font-medium">Contact</th>
                <th className="px-4 py-3 font-medium">Email</th>
                <th className="px-4 py-3 font-medium">Form</th>
                <th className="px-4 py-3 font-medium">Submitted</th>
                <th className="px-4 py-3 font-medium">Status</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((item) => (
                <tr
                  key={item.id}
                  className="border-b border-gray-50 last:border-0 hover:bg-gray-50/60"
                >
                  <td className="px-4 py-4 font-medium text-[#1D2739]">
                    {item.company}
                  </td>
                  <td className="px-4 py-4 text-gray-600">{item.contactName}</td>
                  <td className="px-4 py-4 text-gray-600">{item.email}</td>
                  <td className="px-4 py-4 text-gray-600">{item.formName}</td>
                  <td className="px-4 py-4 text-gray-600">
                    {formatDate(item.submittedAt)}
                  </td>
                  <td className="px-4 py-4">
                    <span className="rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-700">
                      In Progress
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
